// extracted by mini-css-extract-plugin
export var buttonContent = "_23-0";
export var centered = "_23-1";
export var centeredFlex = "_23-2";
export var errorText = "_23-3";
export var icon = "_23-4";
export var iconButtonContent = "_23-5";
export var monospace = "_23-6";
export var padded = "_23-7";